module.exports = __webpack_public_path__ + "static/img/natural-disaster-fund-logo.88be3aaf.png";